export const OrderLocation = (number) => {
  const status = number
  switch (status) {
    case 999:
      return "STOPPED"
    case 0:
      return "Manager"
    case 0.5:
      return "Pre-Payment"
    case 1:
      return "Designer"
    case 2:
      return "Paper M."
    case 3:
      return "Arsoma"
    case 3.5:
      return "Tape"
    case 4:
      return "Viva"
    case 4.5:
      return "Cutter"
    case 5:
      return "Winder"
    case 6:
      return "Warehouse"
    case 7:
      return "Delivered"
    default:
      console.log(`Sorry, no order status here`)
  }
}
